import React, { useEffect, useState } from "react"

import { useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"
import { selectCartState } from "@/store/features/cartSlice"
import Toaster from "@/components/core/GlobalToaster/Toaster"

const GlobalToaster = props => {
  const { authData = {} } = props
  const { toasterTimeout = null } = authData || {}

  const { isAuth = false } = useSelector(selectAuthState)
  const { cart: { lineItems = [] } = {} } = useSelector(selectCartState)
  const [showToaster, setShowToaster] = useState(false)
  const [emptyToasterDisplayed, setEmptyToasterDisplayed] = useState(false)

  const itemsInCart = lineItems.length || 0

  useEffect(() => {
    const timerlocalStorage = setTimeout(() => {
      if (itemsInCart === 0) {
        localStorage.setItem("isToasterDisplayedonEmptyCart", true)
      }
    }, 1500)

    const timerToaster = setTimeout(() => {
      setShowToaster(true)
    }, 500)

    const isToasterDisplayedonEmptyCart = localStorage.getItem(
      "isToasterDisplayedonEmptyCart"
    )
    if (isToasterDisplayedonEmptyCart && itemsInCart === 0) {
      setEmptyToasterDisplayed(true)
    }

    return () => {
      clearTimeout(timerlocalStorage)
      clearTimeout(timerToaster)
    }
  }, [itemsInCart])

  useEffect(() => {
    const timerToaster = setTimeout(() => {
      setShowToaster(false)
    }, toasterTimeout)

    return () => clearTimeout(timerToaster)
  }, [showToaster])

  return (
    <React.Fragment>
      {showToaster && !isAuth && (!emptyToasterDisplayed || itemsInCart > 0) ? (
        <Toaster authData={authData} setShowToaster={setShowToaster} />
      ) : null}
    </React.Fragment>
  )
}

export default GlobalToaster
